@if ({
  priceMediaRequest: priceMediasRequest$ | async,
  }; as content) {
  <div class="simple-card m-t-20">
    <div class="col-12">
      <div class="row">
        <p class="m-b-20">
          See history of your requested price media files in the table below. To make a new request please click the request tab.
        </p>
        <p></p>
      </div>
    </div>
    <form [formGroup]="form" (submit)="getPriceMedias()">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group w custom-date-picker">
            <div class="d-flex v-center m-b-4">
              <label for="requestDateFrom" class="m-0">Request Date From</label>
            </div>
            <p-datepicker
              formControlName="fromDate"
              id="requestDateFrom"
              dateFormat="mm/dd/yy"
              showIcon="true"
              inputStyleClass="form-control"
              placeholder="..."
            ></p-datepicker>
            <cx-form-errors [control]="form.get('fromDate')"></cx-form-errors>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group w custom-date-picker">
            <div class="d-flex v-center m-b-4">
              <label for="requestDateTo" class="m-0">Request Date To</label>
            </div>
            <p-datepicker
              formControlName="toDate"
              id="requestDateTo"
              dateFormat="mm/dd/yy"
              showIcon="true"
              inputStyleClass="form-control"
              placeholder="..."
            ></p-datepicker>
            <cx-form-errors [control]="form.get('toDate')"></cx-form-errors>
          </div>
        </div>
        <div class="col-md-1">
          <button type="submit" class="btn btn-primary btn-sm m-t-28">
            <span class="material-symbols-outlined d-flex"> search </span>
          </button>
        </div>
      </div>
    </form>
  </div>
  @if (!content.priceMediaRequest?.isPristine) {
    <div class="simple-card m-t-20">
      @if (!content.priceMediaRequest?.isLoading) {
        @if (content.priceMediaRequest?.priceMedias?.length) {
          <table-pro [configs]="tableConfig">
            <table class="table-responsive table-md">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Customer Number</th>
                  <th>Request Date</th>
                  <th>Effective Date</th>
                  <th>Format Type</th>
                  <th>Export Types</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                @for (history of content.priceMediaRequest?.priceMedias; track history) {
                  <tr>
                    <td [attr.data-value]="history.mediaRequestID">
                      <span class="responsive-title"> Id:</span>
                      {{ history.mediaRequestID }}
                    </td>
                    <td [attr.data-value]="history.customerNumber">
                      <span class="responsive-title"> Customer Number:</span>
                      {{ history.customerNumber }}
                    </td>
                    <td [attr.data-value]="history.requestDate">
                      <span class="responsive-title"> Request Date:</span>
                      {{ history.requestDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <td [attr.data-value]="history.effectiveDate">
                      <span class="responsive-title"> EffectiveDate:</span>
                      {{ history.effectiveDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <td [attr.data-value]="history.formatType">
                      <span class="responsive-title"> Format Type:</span>
                      {{ history.formatType }}
                    </td>
                    <td [attr.data-value]="history.exportType">
                      <span class="responsive-title"> Export Type:</span>
                      <span class="material-symbols-outlined" pTooltip="{{ history.exportType }}">
                        {{ getExportTypeValueFrom(history.exportType) }}
                      </span>
                    </td>
                    <td [attr.data-value]="history.percentage">
                      <span class="responsive-title"> Status </span>
                      @if (history.percentage !== '100%') {
                        <div class="row">
                          <span class="material-symbols-outlined d-flex"> hourglass_top </span> ({{ history.percentage }})
                        </div>
                      } @else {
                        <div class="row">({{ history.percentage }}) <span class="material-symbols-outlined d-flex"> download </span></div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </table-pro>
        } @else {
          <p class="text-center ff-bold m-0">{{ 'Not Available' }}</p>
        }
      } @else {
        <local-loader></local-loader>
      }
    </div>
  }
}
